import { CelebrityPopup } from '../../views';
import template from './index.jst';
import _ from 'lodash';

export class TippingCelebrityPopup extends CelebrityPopup {
	get template() {
		return template;
	}

	fetchData() {
		return this.collection.show_my({
			comp_id: this.league_id
		});
	}

	addTeams( element ) {
		let is_send_teams = !$(element.currentTarget).hasClass('disable');

		if ( is_send_teams ) {
			let $checked_teams = $('.celebrity-popup-body input:checked'),
				teams = [];

			_.each( $checked_teams, team => {
				teams.push( $(team).val() );
			} );

			let data = {
				comp_id: this.league_id,
				users:     teams
			};

			this.collection.add_celebrity_teams( data );
		}
	}

}

export default TippingCelebrityPopup;